const messages = {
  it: {
    beginReservation: 'Inizio della prenotazione',
    lengthOfTime: 'Durata',
    weeks: 'settimana | settimane',
    More: 'Più',
    contactUsDirectlyForLargerMoves: 'Per traslochi più grandi con uffici o una biblioteca ecc, {0} direttamente.',
    Contact: 'contattateci',
    contact: 'contattateci',
    next: 'Continua',

    monday: 'lunedi',
    tuesday: 'martedì',
    wednesday: 'mercoledì',
    thursday: 'giovedì',
    friday: 'venerdì',
    saturday: 'sabato',
    sunday: 'domenica',

    '2 weeks': '2 settimane',
    '3 weeks': '3 settimane',
    '4 weeks': '4 settimane',
    '5 weeks': '5 settimane',
    '6 weeks': '6 settimane',
    '7 weeks': '7 settimane',
    '8 weeks': '8 settimane',

    pleaseSelectYourItems: 'Seleziona i tuoi articoli',
    notSureCalculateYourNeeds: 'Non sei sicuro? {0}',
    calculateNeeds: 'Calcolate qui il vostro fabbisogno di quantità',
    youShouldRentXXBoxes: 'Dovresti affittare <span>{amount}</span> scatole.',

    deliverBoxToHome: 'Consegna dei box',
    pickUpBoxesYourself: 'Raccogliere i box',
    shippingAddress: 'Indirizzo di consegna',
    beforeMove: 'prima del trasloco',
    pickupAddress: 'Indirizzo di raccolta',
    afterMove: 'dopo il trasferimento',
    Address: 'Nome della via',
    zipCode: 'CAP',
    City: 'Città',
    'Additional Information': 'Ulteriori informazioni',
    sameDeliveryAddressBeforeAndAfterMoving:
      "L'indirizzo di consegna corrisponde all'indirizzo di raccolta dopo il trasferimento",
    pleaseEnterYourAddress: 'Inserisci il tuo indirizzo:',
    pleaseEnterYourZipCode: 'Inserisci il tuo codice postal:',

    yourPersonalData: 'I vostri dati personali',
    Salutation: 'Titolo',
    'First Name': 'Nome',
    'Last Name': 'Cognome',
    Company: 'Società',
    'Email address': 'Indirizzo e-mail',
    Mobile: 'Telefono cellulare',
    Notes: 'Note',
    getYourDataFromSwisspass: 'Prendi i tuoi dati da SwissPass',
    swisspassID: 'Swiss Pass ID',
    'Load data': 'Trasmettere i dati',
    'Do you have voucher?': 'Avete un buono?',
    'Voucher Code': 'Codice buono',
    'Apply Voucher': 'Applicare il buono',
    'I accept the': 'Accetto i termini e {0}',
    'Terms and Conditions': 'le condizioni generali',

    Summary: 'Sommario',
    'Reserve and go to payment': 'alla cassa',

    // Country Selector
    Switzerland: 'Svizzera',
    Germany: 'Germania',
    Austria: 'Austria',
    Liechtenstein: 'Liechtenstein',

    // STEP 4
    swissPassError: 'Sembra che qualcosa sia andato storto. Si prega di provare più tardi.',
    Country: 'Paese',
    HERR: 'Signor',
    FRAU: 'Signora',
    '---': '---',
    fillInIfBusinessOrder: 'Compilare se si tratta di un ordine commerciale.',
    choose: 'Selezionare', // Button on map to select store
    'Remove data': 'Rimuovere i dati',

    // STEP 5
    'Contact Information': 'Informazioni di contatto',
    'Delivery details': 'Indirizzo di consegna',
    'Your Products': 'I vostri prodotti',
    billingAddress: 'Indirizzo della fattura',
    'Pickup place details': 'Dettagli sul luogo di ritiro',
    Date: 'Data',

    // bottom bar
    from: 'A partire da', // Price from
    for: 'Per',
    article: '{amount} articolo | {amount} articoli',

    // MAP
    'User Location': 'La vostra posizione',

    // User needs calculator
    calculator: {
      numberOfRooms: 'Numero di camere',
      numberOfAdults: 'Numero di adulti',
      numberOfYears: 'Numero di anni in questa sede',
    },

    // Payment
    'Payment Form': 'Cassa',

    // Thank you page
    'Thank You!': 'Grazie!',
    'Your reservation was successful.': 'La prenotazione è andata a buon fine.',
    'Please check your email with the reservation details.':
      "Si prega di controllare l'e-mail con i dettagli della prenotazione.",
    'Your reservation number is #{number}': 'Il numero di prenotazione è R#{numero}',
    'After changing any of this value your basket will be cleared.':
      'Dopo aver modificato uno di questi valori, il carrello verrà svuotato.',
    'Please confirm your location:': 'Confermare la propria posizione:',
  },
}

export default messages
